// 客户端不要引用服务端的配置
import cookies from 'src/utils/cookie';

const configs = {
  dev: {
    publicPath: '/hospital/assets',
  },
  test: {
    publicPath: '/hospital/assets',
  },
  pre: {
    publicPath: 'https://static.za-doctor.com/za-asclepius-patient-h5-pre/static',
  },
  prd: {
    publicPath: 'https://static.za-doctor.com/za-asclepius-patient-h5/static',
  },
};

// 在C端，运行时获取环境
const env = cookies.get('_e') || 'dev'; // 默认使用 dev 环境

const config = configs[env] || configs.dev; // 如果找不到配置，默认使用 dev

export default config;
